// extracted by mini-css-extract-plugin
export default {"inlineEdit":"InlineEdit_inlineEdit__cVz8M","icon":"InlineEdit_icon__cxS+H","input":"InlineEdit_input__-X3Kf","empty":"InlineEdit_empty__U8TIK"};